import { useI18n } from "@/context/I18nContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ScrollText, BarChart3 } from "lucide-react";
import { OPS } from "@/constants/testIds";
import FinancialsPage from "@/pages/FinancialsPage";
import FinancialsAnalyticsPage from "@/pages/FinancialsAnalyticsPage";

const FA = OPS.finAnalytics;

const triggerClass =
    "gap-2 rounded-full px-4 py-1.5 text-sm font-semibold text-[color:var(--ink-muted)] transition-[color,background-color] duration-150 ease-out hover:text-[color:var(--ink)] hover:bg-[color:var(--brand-orange-soft)] data-[state=active]:bg-[color:var(--brand-orange)] data-[state=active]:text-white data-[state=active]:shadow-[var(--shadow-sm)]";

export default function FinancialsHub() {
    const { t } = useI18n();

    return (
        <div data-testid={FA.hub} className="space-y-5">
            <Tabs defaultValue="pnl" className="space-y-5">
                <TabsList className="inline-flex h-auto w-full flex-wrap justify-start gap-1 rounded-full border border-[color:var(--border-soft)] bg-[color:var(--bg-surface)] p-1 sm:w-auto">
                    <TabsTrigger data-testid={FA.hubTab("pnl")} value="pnl" className={triggerClass}>
                        <ScrollText className="h-4 w-4" />
                        {t("fa_tab_pnl")}
                    </TabsTrigger>
                    <TabsTrigger data-testid={FA.hubTab("analytics")} value="analytics" className={triggerClass}>
                        <BarChart3 className="h-4 w-4" />
                        {t("fa_tab_analytics")}
                    </TabsTrigger>
                </TabsList>

                <TabsContent value="pnl" className="mt-0 focus-visible:outline-none">
                    <FinancialsPage />
                </TabsContent>
                <TabsContent value="analytics" className="mt-0 focus-visible:outline-none">
                    <FinancialsAnalyticsPage />
                </TabsContent>
            </Tabs>
        </div>
    );
}
